export default __webpack_public_path__ + "static/media/cancel-blue.8b4c59ca.svg";